"use client";

import { cn } from "@/lib/utils";

export type BadgeVariant =
  | "success" | "warning" | "error" | "info" | "primary" | "gray" | "purple";

const variantClasses: Record<BadgeVariant, string> = {
  // `success` memakai token --success-*, bukan green-50/200/700 mentah: hijau
  // hardcoded tidak ikut rebrand tenant dan kontrasnya lebih rendah.
  success: "bg-[var(--success-soft)] border-[var(--success-border)] text-[var(--success)]",
  warning: "bg-amber-50  border-amber-200  text-amber-700",
  error:   "bg-red-50    border-red-200    text-red-700",
  info:    "bg-blue-50   border-blue-200   text-blue-700",
  primary: "bg-[var(--brand-primary-soft)] border-[var(--brand-primary)]/20 text-[var(--brand-primary)]",
  gray:    "bg-zinc-50   border-zinc-200   text-zinc-500",
  purple:  "bg-purple-50 border-purple-200 text-purple-700",
};

/** Bentuk dasar badge — satu-satunya sumber. `StatusBadge` mendelegasikan ke sini. */
export const BADGE_BASE =
  "inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-semibold border";

interface BadgeProps extends React.ComponentPropsWithoutRef<"span"> {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

export function Badge({ children, variant = "gray", className, ...rest }: BadgeProps) {
  return (
    <span className={cn(BADGE_BASE, variantClasses[variant], className)} {...rest}>{children}</span>
  );
}
